import { RootState } from 'app/store';

export const selectBills = (state: RootState) => state.bills.bills;

export const selectTotalPageCount = (state: RootState) =>
  state.bills.totalPageCount;

export const selectTotalBillCount = (state: RootState) =>
  state.bills.totalBillCount;

export const selectLoadingBills = (state: RootState) =>
  state.bills.loadingBills;

export const selectLoadingBillsError = (state: RootState) =>
  state.bills.loadingBillsError;

export const selectCheckedBills = (state: RootState) =>
  state.bills.checkedBills;

export const selectBillFilters = (state: RootState) => state.bills.billFilters;

export const selectCheckboxFilters = (state: RootState) =>
  state.bills.filterCheckboxOptions;
